import ClientsGeneralTab from "./ClientsGeneralTab.jsx";
import ClientTaskHistoryTab from "./ClientsTaskHistoryTab.jsx";
import ClientChecklistTab from "./ClientChecklistTab.jsx";
import ClientRemindersTab from "./ClientRemindersTab.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import MainEditorsBase from "../base/MainEditorBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {DEEP_LINK_URL_KEYS, EDITOR_CONTEXT_MENU_ITEM_KEYS} from "../../../other/constants/OtherKeys.jsx";
import {getEntityShareLink} from "../../../other/utils/otherUtils.jsx";
// import ClientAgendaTab from "./ClientAgendaTab.jsx";
import {canCopyRecord} from "../../../other/utils/editorUtils.jsx";
import ClientNotifyTab from "./ClientNotifyTab.jsx";
import ClientNotesTab from "./ClientNotesTab.jsx";
import ClientContactTab from "./ClientContactTab.jsx";
import ClientFilesTab from "./ClientFilesTab.jsx";
import { SwivuModernEditorMixin } from "../mixin/SwivuModernEditorMixin.jsx";

export default class SwivuClientsEditorV2 extends SwivuModernEditorMixin(MainEditorsBase) {
  static get $name() {
    return "SwivuClientsEditorV2";
  }

  static get type() {
    return WIDGET_KEYS.clientEditorV2Type;
  }

  static get configurable() {
    return {
      ...super.configurable,
      title: "New Client",
      cls: "clients-editor-cls",
      minWidth: "70em",
      maxWidth: "100vw",
      width: "93em",
      stateId: PERSISTENCE_STATE_KEYS.clientEditorV2,
      minHeight: "600px",
      maxHeight: "100vh",
      height: "min(100vh, 800px)",
      closable: true,
      autoClose: false,
      draggable: true,
      // Set this to true to update record immediately as task editor field changes
      autoUpdateRecord: true,
      defaultFocus: (w) => w.ref === "clientNameField",
      items: {
        tabs: {
          type: WIDGET_KEYS.swivuTabPanel,
          stateId: "swivu-client-editor-v2",
          contentElementCls: "clients-editor-content",
          // listeners: {
          //   beforeTabChange: "up.onTabChangeHandler"
          // },
          items: {
            generalTab: { type: ClientsGeneralTab.type },
            notifyTab: { type: ClientNotifyTab.type, swivuDisableOnPhantomRecord: true, },
            contactTab: { type: ClientContactTab, swivuDisableOnPhantomRecord: true, },
            filesTab: { type: ClientFilesTab.type, swivuDisableOnPhantomRecord: true },
            notesTab: { type: ClientNotesTab.type, swivuDisableOnPhantomRecord: true, },
            remindersTab: { type: ClientRemindersTab.type, swivuDisableOnPhantomRecord: true, },
            checklistTab: { type: ClientChecklistTab.type, swivuDisableOnPhantomRecord: true, },
            taskHistoryTab: { type: ClientTaskHistoryTab.type, swivuDisableOnPhantomRecord: true, },
            // clientAgendaTab: { type: ClientAgendaTab.type, swivuDisableOnPhantomRecord: true, },
            // entityPageTab: {
            //   title: "Dashboard",
            //   swivuDisableOnPhantomRecord: true,
            //   tab: {
            //     icon: "fa-regular fa-house",
            //   },
            // }
          }
        }
      },
      listeners: {
        hide: "handleHide"
      },
      bbar: {
        items: {
          dateMetaDataField: {
            type: "label",
          }
        }
      }
    };
  }

  editRecord(record, context, otherParams) {
    super.editRecord(record, context, otherParams);
    this.swivuRecord = record;
    this.updateEditorTitle(record?.name, record);
    const editorTabs = this.widgetMap.tabs;
    const isDemoUser = context.user?.isDemoUser;
    this.loadContextMenu(record, context, isDemoUser, editorTabs);
    this.eachWidget((w) => {
      if (w.isClientsEditorBase) {
        if (otherParams.note && w.type === ClientNotesTab.type) {
          w.editRecord(record, context, { ...otherParams, editor: this, note: otherParams.note });
        } else {
          w.editRecord(record, context, { ...otherParams, editor: this });
        }
      }
    });

    if (otherParams.isFirstShow) this.initializeModernEditor();
  }

  handleHide() {
    this.destroyTabCheckListener();
    //Implementing this logic on the case when user opens dialog for deleting record but cancels it and closes the editor
    if (this.removeListenerAttached) this.removeListenerAttached();
  }

  loadContextMenu(record, context, isDemoUser, editorTabs) {
    const recordType = "client";
    this.configureEditorContextMenu(record, context, {
      recordStore: context.project.clientsStore,
      items: {
        [EDITOR_CONTEXT_MENU_ITEM_KEYS.archiveItem]: { enabled: true },
        [EDITOR_CONTEXT_MENU_ITEM_KEYS.deleteItem]: { enabled: true },
        [EDITOR_CONTEXT_MENU_ITEM_KEYS.shareItem]: {
          enabled: !isDemoUser,
          editorParams() {
            return {
              message: getEntityShareLink({ record, context, editorTabs, entityType: DEEP_LINK_URL_KEYS.client, entityDetail: record }),
            }
          }
        },
        [EDITOR_CONTEXT_MENU_ITEM_KEYS.copyItem]: {
          enabled: canCopyRecord(!isDemoUser, context.selectedBoard, context.boardManager.boardNameStore),
          recordType,
        },
      },
    });
  }

  // onTabChangeHandler({ activeItem, source }) {
  //   if (activeItem.ref === "entityPageTab") {
  //     const { swivuRecord, context } = this;
  //     openEntityManager({
  //       selectedBoard: context.selectedBoard,
  //       recordId: swivuRecord.id,
  //       recordType: ENTITY_TYPES_KEYS.client,
  //       history: context.history,
  //       viewManager: context.viewManager
  //     })
  //     setTimeout(() => {
  //       source.activeTab = 0;
  //       this.hide();
  //     })
  //   }
  // }
}

SwivuClientsEditorV2.initClass();
